import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@sh/components/Utils/icons';
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';

interface FilterDropDownProps {
  appliedFiltersLength: number;
  iconType?: Icons;
  dropdownTitle?: string;
}

interface Emits {
  (e: 'hide', data: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterDropdown.ts',
  props: {
    appliedFiltersLength: null,
    iconType: null,
    dropdownTitle: null
  },
  emits: ["hide"],
  setup(__props: any) {




return { __sfc: true,OptimizerIcon }
}

})